import { pairingTypes } from "src/modules/pairing/constants";

export default function resolveText({
  pairingType,
  familyName,
  requesterFamilyName,
  t,
  deviceName,
  didLogIn,
  didSignUp
}) {
  let successType;
  let value0;
  let value1;
  switch (pairingType) {
    case pairingTypes.INITIAL:
      successType = "initial";
      break;
    case pairingTypes.THEIR_FAMILY_CREATE:
      if (didLogIn) {
        value0 = deviceName;
        successType = "addedToFamily";
      } else if (didSignUp) {
        value0 = familyName;
        successType = "createdFamily";
      } else {
        value0 = deviceName;
        successType = "addedToFamily";
      }
      break;
    case pairingTypes.THEIR_FAMILY:
      if (didLogIn) {
        value0 = deviceName;
        successType = "addedToFamily";
      } else if (didSignUp) {
        value0 = familyName;
        successType = "createdFamily";
      } else {
        value0 = deviceName;
        successType = "addedToFamily";
      }
      break;
    case pairingTypes.OUR_FAMILY_CREATE:
      if (didLogIn) {
        value0 = deviceName;
        successType = "addedToFamily";
      } else if (didSignUp) {
        value0 = familyName;
        successType = "createdFamily";
      } else {
        value0 = familyName;
        successType = "joinedFamily";
      }
      break;
    case pairingTypes.OUR_FAMILY:
      value0 = requesterFamilyName;
      successType = "joinedFamily";
      break;
    case pairingTypes.DEVICES:
      value0 = deviceName;
      value1 = requesterFamilyName ? ` (${requesterFamilyName})` : "";
      successType = "devicesOnly";
      break;
    default:
      successType = pairingType;
      break;
  }
  return t(`pairing.success.text.${successType}`, {
    value0,
    value1
  });
}
